(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Mobile menu ---------- */
  var nav = $('[data-nav]');
  var overlay = $('[data-nav-overlay]');
  var menuToggle = $('[data-menu-toggle]');

  function setMenu(open) {
    if (!nav) return;
    nav.classList.toggle('is-open', open);
    if (overlay) overlay.hidden = !open;
    if (menuToggle) menuToggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('no-scroll', open);
  }
  if (menuToggle) menuToggle.addEventListener('click', function () { setMenu(true); });
  var menuClose = $('[data-menu-close]');
  if (menuClose) menuClose.addEventListener('click', function () { setMenu(false); });
  if (overlay) overlay.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setMenu(false); toggleSearch(false); }
  });

  /* ---------- Search bar ---------- */
  var searchBar = $('[data-search-bar]');
  var searchToggle = $('[data-search-toggle]');
  function toggleSearch(open) {
    if (!searchBar) return;
    searchBar.hidden = !open;
    if (searchToggle) searchToggle.setAttribute('aria-expanded', String(open));
    if (open) { var i = $('input[type="search"]', searchBar); if (i) i.focus(); }
  }
  if (searchToggle) searchToggle.addEventListener('click', function () { toggleSearch(searchBar.hidden); });

  /* ---------- Cart helpers ---------- */
  var toast = $('[data-cart-toast]');
  var toastTimer;
  function showToast() {
    if (!toast) return;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
  }
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      });
  }

  function ajaxAdd(form, button) {
    var label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.classList.add('is-loading'); }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.data.description || res.data.message || 'Could not add to cart.'); return; }
        return refreshCount().then(showToast);
      })
      .catch(function () { form.submit(); })
      .then(function () {
        if (button) { button.disabled = false; button.classList.remove('is-loading'); button.textContent = label; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && (form.matches('[data-add-form]') || form.matches('[data-product-form]'))) {
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      ajaxAdd(form, form.querySelector('button[type="submit"]'));
    }
  });

  /* ---------- Collection sort ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Product page ---------- */
  var product = $('[data-product]');
  if (product) {
    var form = $('[data-product-form]', product);
    var variantsEl = $('[data-variants]', product);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = $('[data-variant-id]', product);
    var priceEl = $('[data-price]', product);
    var compareEl = $('[data-compare]', product);
    var submit = $('[data-submit]', product);
    var submitLabel = $('[data-submit-label]', product);

    var fmt = function (cents) {
      var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      var symbol = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active + ' ' : '';
      return symbol + amount;
    };

    var currentSelection = function () {
      return $$('.opt', product).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    };

    var onVariantChange = function () {
      var sel = currentSelection();
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];

      if (!match) {
        if (submit) { submit.disabled = true; submitLabel.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = fmt(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = fmt(match.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (submit) {
        submit.disabled = !match.available;
        submitLabel.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      if (match.featured_media) { showSlide(match.featured_media.id); }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    };

    $$('.opt input', product).forEach(function (r) { r.addEventListener('change', onVariantChange); });

    /* Quantity */
    var qty = $('[data-qty-input]', product);
    var minus = $('[data-qty-minus]', product);
    var plus = $('[data-qty-plus]', product);
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    /* Gallery */
    var showSlide = function (id) {
      $$('.gallery__slide', product).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') == id); });
      $$('.thumb', product).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') == id); });
    };
    $$('.thumb', product).forEach(function (t) {
      t.addEventListener('click', function () { showSlide(t.getAttribute('data-thumb')); });
    });
  }

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var raw = el.getAttribute('data-countdown');
    var repeat = el.getAttribute('data-repeat') === 'true';
    var end = raw ? new Date(raw).getTime() : NaN;

    var pad = function (n) { return String(n).padStart(2, '0'); };
    var set = function (k, v) { var n = $('[data-cd="' + k + '"]', el); if (n) n.textContent = v; };

    var tick = function () {
      var now = Date.now();
      var target = end;
      if (isNaN(target)) {
        if (!repeat) return;
        var d = new Date(); d.setHours(24, 0, 0, 0);
        target = d.getTime();
      }
      var diff = Math.max(0, target - now);
      set('d', pad(Math.floor(diff / 864e5)));
      set('h', pad(Math.floor(diff % 864e5 / 36e5)));
      set('m', pad(Math.floor(diff % 36e5 / 6e4)));
      set('s', pad(Math.floor(diff % 6e4 / 1e3)));
    };
    tick();
    setInterval(tick, 1000);
  });
})();
